import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { batchEventsConfig } from '@v2/pages/nc-file/details/navigation/config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const NCFileDetailsBatchEventsStack = createStackNavigator();

const NCFileDetailsBatchEventsNavigator = (props: any) => {
  return (
    <NCFileDetailsBatchEventsStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {batchEventsConfig.map(({ Component, name }) => (
        <NCFileDetailsBatchEventsStack.Screen key={name} name={name} component={Component} initialParams={props.route?.params} />
      ))}
    </NCFileDetailsBatchEventsStack.Navigator>
  );
};

export { NCFileDetailsBatchEventsNavigator };
